import React, { useCallback, useEffect, useState } from "react";
import { HiddenEyeIcon, OpenEyeIcon, ThickDownArrowIcon } from "src/components/Icons";
import { usePromptConfirmEvolutive } from "src/hooks";
import * as Ui from "./styles";

export default function Item(props) {
  const {
    // identificador do item
    id,
    // titulo genérico
    tagTitle,
    // ícone referente a tag do item
    TagIcon,
    // texto principal genérico
    mainTitle,
    // flag que indica se o item possui tag
    withTag = false,
    // estilo do checkbox [ circle || square ]
    checkboxStyle,
    // flag que indica se o item é expandível
    expansible = true,
    // indica se o item é deletável (esse item quase sempre é renderizado em um contexto de uma lista)
    removable = false,
    // flag que indica se o item é selecionavel
    selectable = false,
    // flag que indica se o checkbox deve estar em estado de disabled.
    disabledCheckbox = false,
    // flag que indica se o item já está selecionado
    isSelected = false,
    // classe para sobrescrita de estilo padrão
    className,
    // Como os items podem se sobrepor um ao outro, definimos um zIndex para tratar a sobreposição
    // dinamicamente
    zIndex,
    // Comprimento do item
    width,
    // Altura do item
    height,
    // Tamanho minimo do item
    minHeight = "74px",
    // limita o tamanho do container para cada uso
    // por padrão o limite é de 74px;
    maxHeight = "74px",
    // callback criado para controlar o estado do checkbox
    handleOnSelectItem,
    // callback criado para controlar o estado de delete de um item
    onRemove,
    // callback que será disparado ao executar o action de expandir
    onExpand,
    // Modo de posição do componente children {'grow' | 'overflow'}, que será position normal ou absolute.
    childrenDisplayMode = "grow",
    // Controle de estilo e comportamento do item
    renderStyle = "default",
    // Icon que é exibido no lugar do radio ou no checkbox;
    Icon,
    // Icon que é exibido junto no lado esquerdo do título principal
    IconTitle,
    // Componente renderizado ao expandir item
    Children,
    // Propriedade para renderização condicional de estilo quando local for a modal de combinação
    RightContent = null,
    // Propriedade que define o valor inicial de openAlternatives (se o item esta aberto)
    isOpen = false
  } = props;

  const [openAlternatives, setOpenAlternatives] = useState(isOpen);
  const [checked, setChecked] = useState(false);

  // prompt
  const [openPromptConfirmEvolutive, renderPromptConfirmEvolutive] = usePromptConfirmEvolutive()

  useEffect(() => {
    setChecked(!!isSelected);
  }, [isSelected, setChecked]);

  const handleSelectedItems = useCallback(() => {
    if(selectable) {
      const state = !checked;
    setChecked(state);
    if (handleOnSelectItem) {
      handleOnSelectItem({
        id,
        tagTitle,
        mainTitle,
        checked: state,
      });
    }
    }
  }, [checked]);

  const handleOnRemoveItem = useCallback(() => {
    openPromptConfirmEvolutive(() => {
      if (onRemove) onRemove({ id, tagTitle, mainTitle });
    })
  }, [id, tagTitle, mainTitle, onRemove]);

  return (
    <Ui.GenericContainer>
      <Ui.Container
        width={width}
        height={height}
        minHeight={minHeight}
        maxHeight={maxHeight}
        className={className}
        isChecked={checked}
        openAlternatives={openAlternatives}
        renderStyle={renderStyle}
        zIndex={zIndex}
        expansible={expansible}
        isOpen={isOpen}
      >
        <Ui.Wrapper
          isChecked={checked}
          openAlternatives={openAlternatives}
          className="collapsibleWrapper"
        >
          <Ui.SeletableArea selectable={selectable} onClick={handleSelectedItems}>
            {selectable || checkboxStyle ? (
              checkboxStyle === "square" ? (
                <Ui.CheckboxWrapper disabled={disabledCheckbox}>
                  <Ui.CheckboxButton disabled={disabledCheckbox}>
                    <Ui.Square isChecked={checked} className="checkbox" />
                  </Ui.CheckboxButton>
                </Ui.CheckboxWrapper>
              ) : (
                <Ui.CheckboxWrapper disabled={disabledCheckbox}>
                  <Ui.CheckboxButton disabled={disabledCheckbox}>
                    <Ui.Circle isChecked={checked} className="checkbox" />
                  </Ui.CheckboxButton>
                </Ui.CheckboxWrapper>
              )
            ) : (
              <></>
            )}
            {Icon && !selectable && <Icon />}
            <span className="titles">
              <Ui.Tags withTag={!!tagTitle || renderStyle === "stepThreeList"}>
                {tagTitle && (
                  <div className="label">
                    {TagIcon && <TagIcon className="" />}
                    <span>{tagTitle}</span>
                  </div>
                )}
                {renderStyle === "stepThreeList" && (
                  <Ui.Visualized isOpen={isOpen}>
                    <div className="label">
                      {TagIcon &&
                        (isOpen ? <OpenEyeIcon /> : <HiddenEyeIcon />)}
                      <span>{isOpen ? "visualizada" : "não visualizada"}</span>
                    </div>
                  </Ui.Visualized>
                )}
              </Ui.Tags>
              <Ui.QuestionWrapper>
                {IconTitle && <IconTitle className="iconTitle" />}{" "}
                <h2
                  title={mainTitle}
                  dangerouslySetInnerHTML={{ __html: mainTitle }}
                ></h2>
              </Ui.QuestionWrapper>
            </span>
          </Ui.SeletableArea>
          {expansible && (
            <span
              className="select"
              onClick={() => {
                setOpenAlternatives((state) => {
                  const newState = !state;
                  if (onExpand)
                    onExpand(
                      {
                        id,
                        tagTitle,
                        mainTitle,
                      },
                      newState
                    );
                  return newState;
                });
              }}
            >
              <ThickDownArrowIcon className="svgThickArrow" />
            </span>
          )}
          {RightContent && <RightContent />}
        </Ui.Wrapper>
        <Ui.Alternatives
          openAlternatives={openAlternatives}
          childrenDisplayMode={childrenDisplayMode}
        >
          <div className="collapsibleBody">
            {Children && <Children isOpen={openAlternatives} id={id} />}
          </div>
        </Ui.Alternatives>
      </Ui.Container>
      {removable && <Ui.RemoveWrapper onClick={handleOnRemoveItem} />}
      {renderPromptConfirmEvolutive(
        "Excluir pergunta?",
        "Ao excluir a pergunta ela voltará a ser <strong>avulsa</strong> e, se no grupo restar apenas uma pergunta, a combinação será desfeita."
      )}
    </Ui.GenericContainer>
  );
}
